module.exports = __webpack_public_path__ + "img/taoyuan-2.7b532208.jpg";